import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { withRights } from "providers/RightsConsumer";
import { PartnerExtraInformationDataRowComponent } from "./PartnerExtraInformationDataRowComponent";
import { CollapseCard } from "@totalsoft/rocket-ui";
import Description from "@mui/icons-material/Description";
import { Prompt } from "react-router-dom";
import { synchronizationInProgressVar } from "variables";
import { useReactiveVar } from "@apollo/client";

const PartnerExtraInformationComponent = ({
  data,
  onPropertyChange,
  hasWritePermission,
  onAddExtraInfo,
  onDeleteRow,
  countryCode,
  loadPropertyDetails,
  t,
  onSavePartnerExtraInfos,
  saveDisabled,
  validateExtraInformation,
  savedWithMandatoryPropertiesEmpty,
  saving
}) => {
  const [cardExpanded, setCardExpanded] = useState({});
  const [showPrompt, setShowPrompt] = useState(false);
  const synchronizationInProgress = useReactiveVar(synchronizationInProgressVar);

  useEffect(() => {
    setShowPrompt(saveDisabled.some(disabled => !disabled));
  }, [cardExpanded, saveDisabled]);

  const toggleCardExpansion = index => {
    setCardExpanded(prevExpanded => ({
      ...prevExpanded,
      [index]: !prevExpanded[index]
    }));
  };

  return (
    <Grid item xs={12} spacing={1}>
      {showPrompt && <Prompt message={t("LeavingWithoutSaving")} />}
      {data?.sections?.map((section, index) => (
        <CollapseCard
          key={index}
          id={`extraInfoCard-${index}`}
          icon={Description}
          title={section.name}
          expanded={cardExpanded[index]}
          onToggle={() => toggleCardExpansion(index)}
          iconColor="primary"
          defaultExpanded={synchronizationInProgress}
          toggleOnHeaderClick
        >
          <PartnerExtraInformationDataRowComponent
            key={index}
            sectionIdx={index}
            section={section}
            onDeleteRow={onDeleteRow}
            hasWritePermission={hasWritePermission}
            onPropertyChange={onPropertyChange}
            onAddExtraInfo={onAddExtraInfo}
            countryCode={countryCode}
            loadPropertyDetails={loadPropertyDetails}
            t={t}
            onSavePartnerExtraInfos={onSavePartnerExtraInfos}
            saveDisabled={saveDisabled}
            validateExtraInformation={validateExtraInformation}
            savedWithMandatoryPropertiesEmpty={savedWithMandatoryPropertiesEmpty}
            saving={saving}
          />
        </CollapseCard>
      ))}
    </Grid>
  );
};

PartnerExtraInformationComponent.propTypes = {
  idx: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  hasWritePermission: PropTypes.bool.isRequired,
  onAddExtraInfo: PropTypes.func.isRequired,
  onDeleteRow: PropTypes.func.isRequired,
  countryCode: PropTypes.string,
  loadPropertyDetails: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  onSavePartnerExtraInfos: PropTypes.func.isRequired,
  saveDisabled: PropTypes.bool.isRequired,
  validateExtraInformation: PropTypes.func.isRequired,
  savedWithMandatoryPropertiesEmpty: PropTypes.bool.isRequired,
  saving: PropTypes.array.isRequired
};

export default withRights(PartnerExtraInformationComponent);
